import { render, staticRenderFns } from "./PrizesTab.vue?vue&type=template&id=197bb8ea&scoped=true"
import script from "./PrizesTab.vue?vue&type=script&lang=js"
export * from "./PrizesTab.vue?vue&type=script&lang=js"
import style0 from "./PrizesTab.vue?vue&type=style&index=0&id=197bb8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bb8ea",
  null
  
)

export default component.exports